module.exports = __webpack_public_path__ + "img/sixu.c7d41b9d.png";